var React = require('react');

function ArrowRoundedNext (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.5 29.75C10.4577 29.75 4.75 24.0423 4.75 17C4.75 9.95775 10.4577 4.25 17.5 4.25C24.5422 4.25 30.25 9.95775 30.25 17C30.25 24.0422 24.5422 29.75 17.5 29.75Z","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M23.1654 17L11.832 17","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18.918 12.75L23.168 17L18.918 21.25","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ArrowRoundedNext.defaultProps = {"width":"35","height":"34","viewBox":"0 0 35 34","fill":"none"};

module.exports = ArrowRoundedNext;

ArrowRoundedNext.default = ArrowRoundedNext;
